import { useState } from 'react'
import {
  AppBar as BaseAppBar,
  ToggleThemeButton,
  useSidebarState,
} from 'react-admin'
import { Box, IconButton, Popover } from '@mui/material'
import { ZoomIn, ZoomOut } from '@mui/icons-material'
import { darkTheme } from '../Theme/darkTheme'
import FitnessTrackerPopover from './FitnessTracker/FitnessTrackerPopover'
import { canUseFitnessTracker } from './FitnessTracker/Utils/utils'
import FitnessRingsIcon from './FitnessTracker/Components/FitnessRingsIcon'

const AppBar = (props) => {
  const [open, setSidebarState] = useSidebarState()
  const [anchorEl, setAnchorEl] = useState(null)

  const zoomIn = () => {
    if (
      document.body.style.zoom === '' ||
      document.body.style.zoom === '100%'
    ) {
      document.body.style.zoom = '110%'
    } else if (document.body.style.zoom === '85%') {
      document.body.style.zoom = '100%'
    }
  }

  const zoomOut = () => {
    if (
      document.body.style.zoom === '' ||
      document.body.style.zoom === '100%'
    ) {
      document.body.style.zoom = '85%'
    } else if (document.body.style.zoom === '110%') {
      document.body.style.zoom = '100%'
    }
  }
  return (
    <BaseAppBar
      {...props}
      color="primary"
      open={open}
      onLoad={() => {
        setSidebarState(false)
      }}
      position="fixed"
      sx={{
        '.MuiButtonBase-root': {
          border: '0 !important',
        },
      }}
    >
      <Box sx={{ display: 'none', md: { display: 'block' } }}>
        <img src="/scrap-car-comparison.svg" alt="ScrapCarComparison" />
      </Box>
      <span
        style={{
          flex: 1,
        }}
      />
      <IconButton color="inherit" onClick={() => zoomIn()}>
        <ZoomIn fontSize="large" />
      </IconButton>
      <IconButton color="inherit" onClick={() => zoomOut()}>
        <ZoomOut fontSize="large" />
      </IconButton>
      {canUseFitnessTracker(localStorage.getItem('user_id')) && (
        <>
          <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
            <FitnessRingsIcon fontSize="large" />
          </IconButton>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            disableScrollLock
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            PaperProps={{
              style: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            <FitnessTrackerPopover onClose={() => setAnchorEl(null)} />
          </Popover>
        </>
      )}
      <ToggleThemeButton darkTheme={darkTheme} />
    </BaseAppBar>
  )
}

export default AppBar
